import { render, staticRenderFns } from "./AppCreateTask.vue?vue&type=template&id=53ce5c57&"
import script from "./AppCreateTask.vue?vue&type=script&lang=js&"
export * from "./AppCreateTask.vue?vue&type=script&lang=js&"
import style0 from "./AppCreateTask.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports